export default class HouseAdDismissBehavior {}

HouseAdDismissBehavior.NonDismissable = 'non_dismissable';
HouseAdDismissBehavior.TemporaryDismiss = 'temporary_dismiss';
HouseAdDismissBehavior.PersistentDismiss = 'persistent_dismiss';
HouseAdDismissBehavior.SessionDismiss = 'session_dismiss';
HouseAdDismissBehavior.TimedDismiss = 'timed_dismiss';
HouseAdDismissBehavior.TimedSessionDismiss = 'timed_session_dismiss';
